import React from 'react';
import ReviewItemCard from './ReviewItemCard';

const WorksheetCard = ({id, title, selected, onToggle, icon, summary, taskPill}) => (
    <ReviewItemCard
        id={id}
        text={title}
        checked={selected}
        onToggle={onToggle}
        icon={icon}
        summary={summary}
        typePill={taskPill}
    />
);

export default WorksheetCard;
